import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["trackingSource", "productLevel", "screen", "sourceId", "termOverride", "use", "purchaseMotion", "purchaseMotionLocation"];
import CodeSplitEnvWrapper from '../../../components/common/env/CodeSplitEnvWrapper';
import SuiteProductLevelIdentifiersMap from '../../../constants/merchCards/SuiteProductLevelIdentifiersMap';
import { APP } from '../../../constants/tracking/TrackingSources';
import { useAppSelector } from '../../../reducers';
import { suiteProductConfigurationsSelector } from '../../../selectors/ProductConfigsSelectors';
import { quantityPackProductConfigurationsFromProductInventorySelector } from '../../../selectors/ProductInventorySelectors';
import { skuIdHasBundledProductsSelector, upgradeProductSelector } from '../../../selectors/ProductsSelectors';
import { useValidatedCrmSuiteQueryParamTerm } from '../../../utils/urls/appQueryParamUtils';
import LoadingCTA from './LoadingCTA';
import { jsx as _jsx } from "react/jsx-runtime";
export const SuiteCTA = props => {
  const {
      trackingSource,
      productLevel,
      screen,
      sourceId = 'pricing-hero',
      termOverride,
      use = 'primary',
      purchaseMotion,
      purchaseMotionLocation
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    queryParamTerm
  } = useValidatedCrmSuiteQueryParamTerm({
    productLevel
  });
  const suiteProductConfigurations = useAppSelector(state => suiteProductConfigurationsSelector(state, {
    productLevel
  }));
  const upgradeProduct = useAppSelector(state => upgradeProductSelector(state, {
    skuIds: suiteProductConfigurations.map(({
      skuId
    }) => skuId)
  }));
  const upgradeData = {
    app: APP,
    screen,
    uniqueId: `${trackingSource}-${productLevel.toLowerCase()}`,
    upgradeProduct
  };
  const hasBundleSuite = useAppSelector(state => suiteProductConfigurations.find(config => skuIdHasBundledProductsSelector(state, {
    skuId: config.skuId
  })));
  const nonMerchandiseIdIdentifier = hasBundleSuite ? '' : SuiteProductLevelIdentifiersMap[productLevel];
  const ownedQuantityPackProductConfigurations = useAppSelector(state => {
    return quantityPackProductConfigurationsFromProductInventorySelector(state, {
      baseProductConfigurations: suiteProductConfigurations
    });
  });

  // In the case we pass in purchaseMotion by indexing purchaseMotions[0], but the purchaseMotions array is empty. TS won't complain, but it will throw an error at runtime.
  if (!purchaseMotion) return null;
  const checkoutProductConfigurations = [...suiteProductConfigurations, ...ownedQuantityPackProductConfigurations];
  const sharedProps = Object.assign({}, rest, {
    productConfigurations: checkoutProductConfigurations,
    queryParamTerm: termOverride !== null && termOverride !== void 0 ? termOverride : queryParamTerm,
    use: use || 'primary',
    purchaseMotion,
    trackingSource
  });
  return /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
    authedComponentLoader: () => import( /* webpackChunkName: "authed-chunk" */`pricing-pages-ui/components/common/purchaseMotions/PurchaseMotionButtonWrapper`),
    publicComponentLoader: () => import( /* webpackChunkName: "public-chunk" */`pricing-pages-ui/features/purchaseMotions/components/PublicPurchaseMotionButton`),
    authedComponentProps: Object.assign({}, sharedProps, {
      upgradeData,
      nonMerchandiseIdIdentifier,
      purchaseMotionLocation
    }),
    publicComponentProps: Object.assign({}, sharedProps, {
      sourceId,
      dtbSource: `pricing-page|${trackingSource}|suite|${productLevel.toLowerCase()}`,
      hubsSignupProductOverride: SuiteProductLevelIdentifiersMap[productLevel].split('-').join('').toLowerCase()
    }),
    authedComponentLoadingState: LoadingCTA,
    publicComponentLoadingState: LoadingCTA
  });
};